module.exports = __webpack_public_path__ + "static/og-image-df84156e7824faffe59cd06ee28ebbcb.png";